module.exports = __webpack_public_path__ + "static/media/savings-history-empty-state.493bd1cd.svg";